import { Injectable } from '@angular/core';
import { StorageService } from '../storage/storage.service';
import { Definitions } from '../../core/definitions';

@Injectable()
export class TokenService {
  static readonly accessTokenSessionKey: string = 'access_Token';

  constructor(private _storageService: StorageService) {}

  setToken(value) {
    return this._storageService.setItem(TokenService.accessTokenSessionKey, value);
  }

  getToken() {
    return this._storageService.getItem(TokenService.accessTokenSessionKey);
  }

  removeToken() {
    this._storageService.remove(TokenService.accessTokenSessionKey);
  }

  setResourceSharingToken(value) {
    const resourceSharingSession = this._storageService.getItem(Definitions.agentInfoSessionKey);
    resourceSharingSession.agentToken = value;
    this._storageService.setItem(Definitions.agentInfoSessionKey, resourceSharingSession);
  }

  getResourceSharingToken() {
    const resourceSharingSession = this._storageService.getItem(Definitions.agentInfoSessionKey);
    return resourceSharingSession?.agentToken;
  }
}
